"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percent = void 0;
const trimTrailingZeros_1 = require("@uxf/core/utils/trimTrailingZeros");
const percent = (inputValue, maxValue = 100, precision = 2) => {
    if (inputValue === 0) {
        return inputValue;
    }
    return parseFloat((0, trimTrailingZeros_1.trimTrailingZeros)(((inputValue / maxValue) * 100).toFixed(precision)));
};
exports.percent = percent;
